import { createLogger } from 'vue-logger-plugin'

const isProduction = process.env.Environment === 'PRD'

/*
* O logger SEMPRE estará habilitado.
Porém, em produção, o nível de log será 'error' e não será exibido no console.
Isso será útil quando inserirmos webhooks para monitoramento de erros, como
o do #logs-homolog do Slack.
Assim, podemos saber que existem erros antes mesmo de um usuário reportar.
*/
const logger = createLogger({
  enabled: true,
  consoleEnabled: !isProduction,
  level: isProduction ? 'error' : 'debug',
  callerInfo: true,
})

// fora de um componente Vue, importe e use logger diretamente
export { logger }

// use this.$logger em componentes Vue
export default {
  install(VueInstance, options) {
    VueInstance.prototype.$logger = logger
    VueInstance.prototype.console = console
  },
}
